"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  containerDeleteButton: {
    display: 'flex',
    position: 'absolute',
    top: 12,
    left: 12
  },
  deleteButton: {
    borderRadius: '50%',
    minWidth: 'auto',
    border: '1px solid #F9685C',
    backgroundColor: 'white',
    color: '#F9685C',
    "&:hover": {
      backgroundColor: '#F9685C',
      color: 'white'
    }
  },
  containerImageAlbum: {
    position: 'relative',
    "@media screen and (max-width: 600px)": {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      height: 250
    },
    width: '100%',
    height: 200
  },
  containerImage: {
    position: 'relative',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: '100%',
    height: 300
  },
  containerAgregarFotos: {
    textAlign: 'center'
  },
  blur: {
    '- webkit - filter': 'blur(2px)',
    'filter': 'blur(2px)'
  },
  progressContainer: {
    position: 'absolute',
    left: '50%',
    marginLeft: '-20px',
    top: '50%',
    marginTop: '-20px'
  }
});

exports.default = _default;